<script lang="ts" setup>
import UiHeader from '@/components/UiHeader/UiHeader.vue'
import UiDrawer from '@/components/UiDrawer/UiDrawer.vue'
import UiSection from '@/components/UiSection/UiSection.vue'
import type { IDrawer } from '@/components/UiDrawer/UiDrawer.types'

const { t } = useI18n()

const faqItems: IDrawer[] = [
  {
    header: 'multiteatr.faq.items.q1.question',
    description: 'multiteatr.faq.items.q1.answer',
  },
  {
    header: 'multiteatr.faq.items.q2.question',
    description: 'multiteatr.faq.items.q2.answer',
  },
  {
    header: 'multiteatr.faq.items.q3.question',
    description: 'multiteatr.faq.items.q3.answer',
  },
  {
    header: 'multiteatr.faq.items.q4.question',
    description: 'multiteatr.faq.items.q4.answer',
  },
  {
    header: 'multiteatr.faq.items.q5.question',
    description: 'multiteatr.faq.items.q5.answer',
  },
  {
    header: 'multiteatr.faq.items.q6.question',
    description: 'multiteatr.faq.items.q6.answer',
  },
  {
    header: 'multiteatr.faq.items.q7.question',
    description: 'multiteatr.faq.items.q7.answer',
  },
  {
    header: 'multiteatr.faq.items.q8.question',
    description: 'multiteatr.faq.items.q8.answer',
  },
]

const activeDrawersFaqValues = ref<number[]>([0])

const checkIsOpenDrawer = (index: number) => {
  return activeDrawersFaqValues.value.includes(index)
}

const toggleFaqValuesDrawer = (index: number) => {
  if (activeDrawersFaqValues.value.includes(index)) {
    activeDrawersFaqValues.value = activeDrawersFaqValues.value.filter(el => el !== index)

    return
  }

  activeDrawersFaqValues.value.push(index)
}
</script>

<template>
  <UiSection
    id="faq"
    class="faq-section"
  >
    <UiHeader
      :header="t('multiteatr.faq.header')"
      position="center"
      class="faq-header"
      header-size="h5"
      header-size-tablet="h5"
      header-size-mobile="h5"
    />

    <div class="section__container">
      <UiDrawer
        v-for="(drawer, index) in faqItems"
        :key="drawer.header"
        :class="{ 'faq-drawer--open': checkIsOpenDrawer(index) }"
        :header="t(drawer.header)"
        :description="t(drawer.description)"
        :variant="'tertiary'"
        :is-open="checkIsOpenDrawer(index)"
        @clicked="() => { toggleFaqValuesDrawer(index) }"
      />
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>

:deep(.ui-header) {
   @include header-investor();
}

.faq-section {
  margin-top: 4.8rem;
}

:deep(.single-drawer) {
  margin-bottom: 2.4rem;
  padding: 2.4rem;
  border: 1px solid $color-gray-blue-50;
}

:deep(.single-drawer__description-line) {
  display: none;
  background-color: transparent;
}

:deep(.single-drawer__description) {
  padding: 0;
  background-color: transparent;

  p {
    @include body-3;
    padding-bottom: 1.6rem;
    color: $text-300;

    &:last-of-type {
      padding-bottom: 0;
    }
  }

  a {
    color: $blue-400;
    text-decoration: underline;
  }
}

:deep(.single-drawer__header-icon) {
  min-width: 2.4rem;
  width: 2.4rem;
  height: 2.4rem;
  background-image: url('/icons/arrow_down_purple.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 0;
  transition: transform 0.3s ease;
}

:deep(.single-drawer__header-icon-line) {
  display: none;
}

:deep(.faq-drawer--open.single-drawer .single-drawer__header-icon) {
  transform: rotate(180deg);
}

@include atM {
  :deep(.investorHero__content) {
    max-width: 40rem;
  }
}

@include atL {
  :deep(.investorHero__content) {
    max-width: 49rem;
  }
}
</style>
